
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { ArrowLeft, Home } from "lucide-react";
import { requiresAuth, checkAuthStatus } from "@/utils/deepLinking";

const NotFound = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const path = location.pathname;

  useEffect(() => {
    const checkPath = async () => {
      console.error(
        "404 Error: User attempted to access non-existent route:",
        path
      );
      
      // If the route requires auth, check if user is authenticated
      if (requiresAuth(path)) {
        const isAuthenticated = await checkAuthStatus();
        if (!isAuthenticated) {
          // Redirect to auth page if not authenticated
          navigate('/auth');
        }
      }
    };
    
    checkPath();
  }, [path, navigate]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-900 text-white px-4">
      <div className="text-center max-w-md">
        <h1 className="text-6xl font-bold mb-4 text-blue-500">404</h1>
        <p className="text-xl text-gray-300 mb-8">
          The page you're looking for couldn't be found
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button 
            variant="outline" 
            className="border-blue-500 text-blue-400 hover:bg-blue-500/10"
            onClick={() => navigate(-1)}
          >
            <ArrowLeft className="mr-2 h-4 w-4" />
            Go Back
          </Button>
          
          <Button 
            className="bg-blue-600 hover:bg-blue-700 text-white"
            onClick={() => navigate('/')}
          >
            <Home className="mr-2 h-4 w-4" />
            Return Home
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
